import { PlatformType } from '@/enums/business'
import useLoginStore from '@/store/login/login'
import { storeToRefs } from 'pinia'

export function usePlatform() {
  const loginStore = useLoginStore()
  const { platFormInfo } = storeToRefs(loginStore)

  // 2. Getter 手动包一层 computed，保证响应式实时追踪
  const platformType = computed(() => loginStore.platformType)
  const platformSelection = computed(() => loginStore.platformSelection)
  const isSelfStudy = computed(() => loginStore.isSelfStudy)
  const isAdultEducation = computed(() => loginStore.isAdultEducation)
  const isComprehensiveEvaluation = computed(
    () => loginStore.isComprehensiveEvaluation
  )
  const isStudyPlatform = computed(() => loginStore.isStudyPlatform)

  const isPlatform = (...types: PlatformType[]) => {
    return types.includes(loginStore.platformType as PlatformType)
  }

  return {
    platFormInfo,
    platformSelection,
    platformType,
    isSelfStudy,
    isAdultEducation,
    isComprehensiveEvaluation,
    isStudyPlatform,
    isPlatform,
    PlatformType
  }
}
